<template>
  <div class="modal fade" id="imageadd" role="dialog">
    <div class="modal-dialog" :class="size">
      <div class="modal-content">
        <div class="modal-body">
          <div class="flexbox">
            <div class="col-sm-12">
              <image-input
                :uploadUrl="'Product/judge-image'"
                :asin="this.asin"
                :shareLink="this.shareLink"
                @close="$emit('close')"
                @refresh="$emit('refresh')"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageInput from '@/components/ImageInput'
export default {
  components: {
    ImageInput
  },
  props: {
    asin: {
      type: String,
      default: ''
    },
    shareLink: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'modal-xl'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/productsNew/ProductNewImageAdd.vue